export default __webpack_public_path__ + "static/media/gollums_gems.76d99957.jpeg";